import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { COMPANY_PREFIX, COMPANY_TYPE, COMPANY_TYPE_LIST } from '../constants/company';
export function isHsmsf() {
  return window.location.pathname.startsWith(COMPANY_PREFIX[COMPANY_TYPE.HSMSF]);
}
export function isPgqjywyh() {
  return window.location.pathname.startsWith(COMPANY_PREFIX[COMPANY_TYPE.PGQJYWYH]);
}
export function getCurCompany() {
  var pathName = window.location.pathname;
  var _iterator = _createForOfIteratorHelper(COMPANY_TYPE_LIST),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var type = _step.value;
      // if (pathName.startsWith(COMPANY_PREFIX[type.value])) {
      if (pathName.includes(COMPANY_PREFIX[type.value])) {
        return type.value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return COMPANY_TYPE.FEIXIANG;
}